import React from 'react';

import { ProcessStepContent } from './components/process-step-content';
import type { OfflineSalesStepsProps } from './offline-sales-steps.type';

/*
 * OfflineSalesSteps Component
 *
 * Pure component that renders the specific steps for the Offline Sales process.
 * Receives all data and handlers as props from the parent ProcessOfflineSales component.
 */
export const OfflineSalesSteps: React.FC<OfflineSalesStepsProps> = (props) => {
  return <ProcessStepContent {...props} />;
};
